import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as signalR from '@microsoft/signalr';
import { ToastrService } from 'ngx-toastr';

import { BehaviorSubject, Observable, map } from 'rxjs';
import { DataService } from 'src/app/helpers/data.service';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  // private readonly _getUnreadNotifications = `${environment.base_url}/api/Notification/GetUnreadNotifications`;
  private readonly _getAllNotifications = `${environment.base_url}/api/Notification/GetAllNotifications`;
  private readonly _addNotification = `${environment.base_url}/api/Notification/Add`;
  private readonly _read = `${environment.base_url}/api/Notification/Read`;
  private readonly _markAllAsRead = `${environment.base_url}/api/Notification/MarkAllAsRead`;
  private readonly _notificationHubUrl = `${environment.base_url}/notificationHub`;

  public connection = new signalR.HubConnectionBuilder()
    .withUrl(this._notificationHubUrl)
    .configureLogging(signalR.LogLevel.None)
    .build();

  private _notificationsSource: BehaviorSubject<any[]>;
  public notifications$: Observable<any[]>;

  get notificationsValue(): any[] {
    return this._notificationsSource.value;
  }

  constructor(
    private _http: HttpClient,
    private _dataServ: DataService,
    private _toastrServ: ToastrService,
    private _router: Router
  ) {
    this._notificationsSource = new BehaviorSubject<any[]>([]);
    this.notifications$ = this._notificationsSource.asObservable();

    this.connection.onclose(async () => {
      await this.start();
    });
    this.connection.on('ReceiveNotification', (res: any) => {
      if (
        ~res.specificUsers.findIndex(
          (x: any) => x.userId == _dataServ.userValue?.id
        ) ||
        ~res.employeeTypes.findIndex(
          (x: any) =>
            x.employeeType == _dataServ.userValue?.role ||
            x.employeeType == _dataServ.empTypeValue
        )
      ) {
        this._notificationsSource.next([
          this.processNotification(res),
          ...this.notificationsValue,
        ]);
        const audio = new Audio('../../../../../assets/audio/notification.mp3');
        audio.play();
        this.notifyMe(res);
      }
    });
    _dataServ.user$.subscribe((v) => {
      if (v) {
        this.GetAllNotifications();
      }
    });
  }
  public async start() {
    if (this._dataServ.tokenValue && this.connection.state == 'Disconnected')
      try {
        await this.connection.start();
      } catch (err) {
        console.warn(err);
        setTimeout(() => this.start(), 5000);
      }
  }
  // GetUnreadNotifications() {
  //   return this._http.get<any[]>(this._getUnreadNotifications, {
  //     responseType: 'json',
  //   });
  // }
  processNotification(notification: any) {
    if (
      ~notification.usersWhoRead.findIndex(
        (x: any) => x.userId == this._dataServ.userValue?.id
      )
    )
      notification.unread = false;
    else notification.unread = true;
    return notification;
  }
  GetAllNotifications() {
    this._http
      .get<any[]>(
        `${this._getAllNotifications}?UserId=${this._dataServ.userValue!.id
        }                `,
        {
          responseType: 'json',
        }
      )
      .pipe(
        map((notifications) =>
          notifications
            .map((notification) => this.processNotification(notification))
            .reverse()
        )
      )
      .subscribe({
        next: (res) => {
          this._notificationsSource.next(res);
        },
        error: () => {
          this._toastrServ.error(
            'Something went wrong while fetching notifications...'
          );
        },
      });
  }
  AddNotification(payload: any) {
    return this._http.post<any>(this._addNotification, payload, {
      responseType: 'json',
    });
  }
  Read(notificationId: string) {
    this._http
      .post(
        this._read,
        {
          userId: this._dataServ.userValue!.id,
          notificationId,
        },
        { responseType: 'json' }
      )
      .pipe(
        map((res) => {
          let notifications = [...this.notificationsValue];
          const index = notifications.findIndex((x) => x.id == notificationId);
          if (~index) {
            notifications[index] = { ...notifications[index], unread: false };
            this._notificationsSource.next(notifications);
          }
          return res;
        })
      )
      .subscribe({
        error: () => {
          this._toastrServ.error(
            'Something went wrong while marking notification as read.'
          );
        },
      });
  }
  MarkAllAsRead() {
    this._http
      .post(
        `${this._markAllAsRead}?UserId=${this._dataServ.userValue!.id}`,
        null,
        {
          responseType: 'json',
        }
      )
      .pipe(
        map((res) => {
          let notifications = [...this.notificationsValue];
          notifications.forEach((n) => {
            n.unread = false;
          });
          this._notificationsSource.next(notifications);
          return res;
        })
      )
      .subscribe({
        error: () => {
          this._toastrServ.error(
            'Something went wrong while marking all notifications as read.'
          );
        },
      });
  }

  notifyMe(data: any) {
    if (!window.Notification) {
      console.warn('Browser does not support notifications.');
    } else {
      const notify = () => {
        const regex = /<[^>]*>/g;
        const textOnly = data.title?.replace(regex, '');
        const noti = new Notification(textOnly, {
          body: data.content,
          icon: '/assets/images/logo/logo.2.png',
          silent: true,
          // requireInteraction: true,
        });
        noti.onclick = (event) => {
          event.preventDefault();
          window.focus();
          this._router.navigate(
            [
              data.for == 'task'
                ? '/i-team/tasks/view'
                : '/lead-konnekt/tickets',
            ],
            {
              queryParams: { id: data.tcId },
            }
          );
          this.Read(data.id);
        };
      };
      const ask = () => {
        Notification.requestPermission()
          .then(() => {
            notify();
          })
          .catch(() => {
            ask();
          });
      };
      if (Notification.permission === 'granted') {
        notify();
      } else {
        ask();
      }
    }
  }
}
